module.exports = __webpack_public_path__ + "img/ic_tripadvisor-5.0.5e43fd8f.svg";